<template>
  <section>

    <section
      id="services">
      <v-parallax
        src="fond8_noblur.jpg"
        top
        height="380"
        class="gradienthero">
        <v-overlay
          :absolute="true"
          :value="true"
        >
          <v-layout
            column
            align-center
            justify-center>
            <div class="display-2 font-weight-bold white--text mb-4 text-center text-uppercase">Expertise</div>
            <em>Notre expertise au service de vos projets</em>
          </v-layout>
        </v-overlay>
      </v-parallax>
    </section>

    <section>
      <v-container grid-list-xl>
        <v-layout
          wrap
          justify-center
          class="my-12">
          <v-flex
            xs12
            sm12>
            <v-card-title
              primary-title
              class="layout justify-center">
              <div class="headline">Experts depuis 1995</div>
            </v-card-title>
            <v-card-text>
              L’Entreprise est <span class="font-weight-bold">spécialisée dans la pose de plafond tendu NEWMAT depuis 1995</span>.
              Dans son activité l’entreprise peut prendre en charge toutes les travaux pour la pose d’un plafond tendu.<br>
              Nous prévoyons dans votre devis :<br>
              <ul>
                <li>La pose de spots encastrés, de luminaires, de VMC, de climatisation et tout ce qui peut être encastré dans un plafond tendu.</li>
                <li>La découpe de caisson à rideaux pour faciliter l’accès en cas de démontage, voire la fabrication de caisson simple.</li>
                <li>Tout ce qui concerne le passage de tuyaux de chauffage ou d’eau, s’il faut fabriquer un bandeau ou autre.</li>
              </ul><br>
              En règle générale tout sera mis en œuvre pour que <span class="font-weight-bold">notre entreprise assure seule la pose de votre plafond tendu</span>.
            </v-card-text>
          </v-flex>
          <v-flex
            sm6>
            <div class="video-container">
              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/RH3Z3hqm_PI"
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen/>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
  </section>
</template>

<script>

export default {
  metaInfo () {
    return {
      title: 'Plafond et mur tendus NEWMAT Annecy'
    }
  }
}
</script>

<style lang="scss">

.video-container {
border-radius: 7px;
position: relative;
padding-bottom: 56.25%;
padding-top: 30px;
height: 0;
overflow: hidden;
}

.video-container iframe,
.video-container object,
.video-container embed {
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100%;
}
</style>
